/**
 * @readonly
 * @enum {string}
 */
export const CameraOperationModes = {
    PRIMARY: 'PRIMARY',
    SECONDARY: 'SECONDARY'
}
